import React from "react";

import { Stack } from "react-bootstrap";

import classNames from "classnames";
import { Link } from "react-router-dom";

import styles from "./DashboardFooter.module.scss";

export const DashboardFooter: React.FC = () => {
  return (
    <Stack as="footer" className={styles["footer"]} direction="horizontal">
      <Stack direction="horizontal" gap={3} className={styles["footer-left"]}>
        <div className={classNames(styles["footer-text"], "b4 medium")}>Resale Royalty</div>
        <Link to="/" className={classNames(styles["footer-link"], "b4 medium")}>
          Home
        </Link>
        <Link to="/" className={classNames(styles["footer-link"], "b4 medium")}>
          Legal & Policy
        </Link>
      </Stack>
      <Stack direction="horizontal" gap={3} className={classNames(styles["footer-right"], "ms-auto")}>
        <span className={classNames(styles["footer-text"], "b4 medium")}>Need help? </span>
        <Link to="/contact-us" className={classNames(styles["footer-link"], "b4 bold")}>
          Contact us
        </Link>
      </Stack>
    </Stack>
  );
};
